import React from 'react';

//TODO - add placeholder for each component
export default () => {
	return null;
};
